import { ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { BoardSelectDate, BoardTimeSelectComponent } from './board-time-select/board-time-select.component';
import { Gesture, IonContent, IonInput, createGesture } from '@ionic/angular';
import {Task} from "../../_interfaces/Task"
import { BoardUserSelectComponent } from './board-user-select/board-user-select.component';
import { BoardTagSelectComponent } from './board-tag-select/board-tag-select.component';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { StorageManagerService } from 'src/app/_provider/storage-manager.service';
import { PopoverListItem, PopoverPage } from 'src/app/_template/popover/popover.page';
import { TicketBase } from 'src/app/_interfaces/ticket';
import { AddTicketPage } from 'src/app/_template/popup-content/add-ticket/add-ticket.page';
import { GeneralService } from 'src/app/_provider/general.service';
import { TicketDetailPagePage } from '../ticket-detail-page/ticket-detail-page.page';
import { MenuService } from 'src/app/_provider/menu.service';
import { BreadcumbService } from 'src/app/_provider/breadcumb.service';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { BoardEdiorviewerSelectComponent } from './board-ediorviewer-select/board-ediorviewer-select.component';
import { BoardCardView, BoardCardViewEditorComponent } from './board-card-view-editor/board-card-view-editor.component';
import { SocketMessageData, SocketsService } from 'src/app/_provider/sockets.service';
import * as signalR from '@microsoft/signalr';
import { BoardsGestures } from './boards-gestures';
import { BoardTemplateEditPage } from './board-template-edit/board-template-edit.page';
import { BoardTemplateService, BoardTemplate } from 'src/app/_provider/boards/board-template.service';
import { TicketTagColored, BoardService, BoardEditorFilter } from 'src/app/_provider/boards/board.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_provider/auth.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';


export interface Board{
  id: number,
  hidden?: boolean
  label: string
  ticketCount?: number
  tickets: BoardTicket[]
  hasNotMoreTickets?: boolean
}

export interface BoardTicket{
  id: number,
  description: string,
  number: string,
  addressSearchText?: string,
  sort: number,
  state?: number,
  tasks?: Task[]
  highlighted?: boolean,
  fileCount?: number,
  tags?: number[],
  targetTimeWorkstepId?: number
  timeline?: BoardTagetTimeline
  priority?: string,
  coloredTags?: TicketTagColored[]
  employees?: {id: number, firstName?: string, lastName?: string}[]
}

export class BoardTagetTimeline{

  public targetTimeMinutes: number
  public currentTimeMinutes: number

  public workstepId: number | undefined

  
  constructor(targetTimeNumber: number, currentTimeNumber: number, workstepId: number | undefined){
    this.targetTimeMinutes = targetTimeNumber == 0 ? 0 : targetTimeNumber / 60
    this.currentTimeMinutes = currentTimeNumber
    this.workstepId = workstepId
  }

  public get hasTargetTime(): boolean{
    return !!this.workstepId
  }

  public get percent(): number{
    return this.targetTimeMinutes == 0 ? 0 : ( this.currentTimeMinutes / this.targetTimeMinutes) * 100
  }
  public get targetTimeFormatted(): string{
    const targetTimeMinutes = this.targetTimeMinutes;
    const totalMinutes = targetTimeMinutes;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  public get currentTimeFormatted(): string{
    const targetTimeMinutes = this.currentTimeMinutes;
    const totalMinutes = targetTimeMinutes;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

}


@Component({
  selector: 'app-boards',
  templateUrl: './boards.page.html',
  styleUrls: ['./boards.page.scss'],
})
export class BoardsPage extends BoardsGestures implements OnInit {

  position: { x: number, y: number } = { x: 0, y: 0 };

  @HostListener('mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    this.position.x = event.clientX;
    this.position.y = event.clientY;
  }

  @ViewChild("searchInput", {static: false}) private searchInput: ElementRef
  @ViewChild("addTagInput", {static: false}) private addTagInput: IonInput
  @ViewChild(IonContent) private ionContentViewChild: IonContent
  @ViewChild("settingsWrapper", {static: false}) private settingsWrapper: ElementRef
  @Input() isSinglePage: boolean = false

  @HostBinding("style.--settings-wrapper-height")
  public settingsWrapperHeight: string = "74px"

  public categoryDetails: string = "projects"
  public selectedDate: BoardSelectDate = {name: "Alle", value: "all"}

  public searchOpen: boolean = false
  public searchText: string = ""
  
  public addTagOpen: boolean = false
  public addTagText: string = ""


  public wrapperHeaderFixxed: boolean = false


  public loadLength: number = 3

  public coloredBoards: boolean = true

  public changedFilter: {color: boolean, statusView: boolean, cardView: boolean} 

  constructor(
    public changeDetector: ChangeDetectorRef,
    private feedback: FeedbackService,
    private menuSrv: MenuService,
    private storageManager: StorageManagerService,
    public boardSrv: BoardService,
    private hotkeySrv: HotkeysService,
    public socketSrv: SocketsService,
    public genralSrv: GeneralService,
    public breadcrumbSrv: BreadcumbService,
    private authSrv: AuthService,
    public resizeManager: ResizeManagerService,
    public boardTemplateSrv: BoardTemplateService,
    private router: Router
  ) { 
    super(boardSrv, changeDetector, socketSrv)

    this.hotkeySrv.add(new Hotkey(["meta+f", "ctrl+f"], (event: KeyboardEvent): boolean=>{
      this.openSearch()
      return false
    }))
  }


  async ngOnInit() {
    if(!this.genralSrv.serverVersionGreaterThan("1.7.0")) return

    this.breadcrumbSrv.routeChange().subscribe(async (route: string)=>{
      if(route == "tabs/boards" || this.isSinglePage) {
        this.breadcrumbSrv.breadcrumbs = [{
          name: "Boards"
        }]
        if(this.boardTemplateSrv.templates.length > 0) this.setBreadcrumbButtons(false)
        await this.listenToSocketEvents()
      }else {
        this.socketSrv.removeHandler("BoardItemChanged")
        if(!this.isSinglePage) this.breadcrumbSrv.hideOnSmallDevices = true
      }
    })

    this.boardSrv.loadEmployees().then(()=>this.boardTemplateSrv.getAllBoardTemplates())
    this.boardTemplateSrv.reloadBoard = async () => await this.loadBoard()
    this.boardTemplateSrv.setBreadcrumButtons = (setEmpty: boolean = false) => this.setBreadcrumbButtons(setEmpty)
    this.resetFilterChanged()

  } 

  async ngAfterViewInit(){
    this.ionContent = this.ionContentViewChild;
    const scrollElement: HTMLElement = await this.ionContent.getScrollElement()
    scrollElement.addEventListener("mousemove", (event: MouseEvent)=>this.detectIndicator(event))
    scrollElement.addEventListener("touchmove", (event: TouchEvent)=>this.detectIndicator(event))
      
  }
  
  /**
   * Setzt die Breadcrumb-Buttons
   */
  private setBreadcrumbButtons(setEmpty: boolean = false){

    if(setEmpty) this.breadcrumbSrv.buttons = []
    else this.breadcrumbSrv.buttons = [
      // {ionIcon: "fa-calendar", title: "Zeitraum auswählen", action: async ()=>await this.openTimeSelect()},
      {ionIcon: "fa-list", title: "Ansicht der Cards", action: async (event)=>await this.openCardViewEditor(event)},
      {ionIcon: "fa-colors", title: "Farblich unterlegen", action: async ()=>{
        this.changedFilter.color = true
        this.boardSrv.coloredBoards = !this.boardSrv.coloredBoards
        this.boardTemplateSrv.activeBoardTemplate.colored = this.boardSrv.coloredBoards
      }},
      {ionIcon: "fa-search", title: "Suchen", action: ()=>this.openSearch()},
      {ionIcon: "fa-rotate", title: "Neu laden", action: async ()=>{
        await this.boardTemplateSrv.getAllBoardTemplates(this.boardTemplateSrv.activeBoardTemplate?.id)
      }},
      {ionIcon: "fa-ellipsis-vertical", title: "Board-Einstellungen", action: async (event)=>await this.boardTemplateSrv.openEditMenu(event)},
    ]
  }

  public get isSomeOneHidden(): boolean{
    return this.boardSrv.boards.some(b =>b.hidden) 
  }

  public get anyFilterChangedLength(): number{
    return Object.values(this.changedFilter).filter(v => v).length
  }

  public resetFilterChanged(){
    this.changedFilter = {
      color: false,
      statusView: false,
      cardView: false
    }
  }

  /**
   * Initialisiert die Socket-Ereignisüberwachung.
   * Wenn der Socket nicht verbunden ist, wird er initialisiert.
   * Registriert einen Handler für das Ereignis "BoardItemChanged",
   * der aufgerufen wird, wenn sich ein Boardelement ändert.
   * Aktualisiert das entsprechende Ticket und verschiebt es in das
   * neue Board gemäß den übermittelten Daten.
   */
  private async listenToSocketEvents(){

    if(this.socketSrv.socketState != signalR.HubConnectionState.Connected) await this.socketSrv.initializeSocket()
    this.socketSrv.registerHandler("BoardItemChanged", (data: SocketMessageData<{ticketId: number, statusId: number, position: number}>)=>{
      const currentBoard: Board = this.boardSrv.boards.find(b => b.tickets?.find(t => t.id == data.data?.ticketId))
      if(!currentBoard) return
      
      const ticket: BoardTicket = currentBoard.tickets.find(t => t.id == data.data.ticketId)
      if(!ticket) return

      ticket.state = data.data.statusId
      ticket.sort = data.data.position
      const newBoard = this.boardSrv.boards.find(b => b.id == data.data.statusId)

      if(!newBoard) return 

      if(newBoard.id == currentBoard.id) return

      newBoard.tickets.unshift(ticket)
      newBoard.tickets.sort((a, b) => a.sort > b.sort ? 1 : a.sort === b.sort ? 0 : -1)
      currentBoard.tickets = currentBoard.tickets.filter(t => t.id != data.data.ticketId)

      this.changeDetector.detectChanges()
    })
  }

  /**
   * Wählt ein Template aus und lädt das Board neu.
   * @param template 
   */
  public async selectTemplate(template: BoardTemplate){
    this.resetFilterChanged()
    await this.boardTemplateSrv.selectBoardTemplate(template)
  }

  /**
   * Lädt das Board und initialisiert die Drag-Geste.
   */
  public async loadBoard(){
    this.resetFilterChanged()
    this.boardTemplateSrv.isLoading = true

    const hiddenBoardIds: number[] = this.boardTemplateSrv.activeBoardTemplate?.boardStatusViewSelect?.filter(v => !v.active)?.map(v => v.id) || []

    await this.boardSrv.loadBoards(this.selectedDate, this.searchText, hiddenBoardIds)
    this.boardTemplateSrv.isLoading = false
    this.changeDetector.detectChanges()
    this.dropableElements = Array.from(document.querySelectorAll('.board-wrapper-dropable'))
    this.dropableBoardLines = Array.from(document.querySelectorAll(".board-drop-line"))
    this.hiddenBoards = Array.from(document.querySelectorAll(".hidden-group-item"))
    // this.scrollWrapper = Array.from(document.querySelectorAll(".scroll-wrapper"))
    this.initBoardDragGesture()
  }

  /**
   * Lädt die Offset-Daten für das angegebene Board und aktualisiert die Ansicht.
   * @param board - Das Board, für das die Offset-Daten geladen werden sollen.
   * @param event - Das Event-Objekt, das den Aufruf ausgelöst hat.
   * @returns Eine Promise, die aufgelöst wird, sobald die Offset-Daten geladen wurden.
   */
  public async loadOffset(board: Board, event: any){
    event.stopPropagation()
    await this.boardSrv.getOffset(board, this.selectedDate, this.searchText)
    this.changeDetector.detectChanges()
    this.dropableElements = Array.from(document.querySelectorAll('.board-wrapper-dropable'))
  }

  public openSearch(){
    this.searchInput.nativeElement.focus()
    this.searchOpen = true
  }
  
  public searchBlur(){
    if(this.searchText) return
    this.searchOpen = false
  }

  private isTypingTimer: any
  public searchKeyUp(){
    clearTimeout(this.isTypingTimer)
    this.isTypingTimer = setTimeout(async () => await this.loadBoard(), 300);
  }

  public async createTemplate(){
    await this.feedback.openModal(BoardTemplateEditPage)
  }

  public async createDefaultTemplate(){
    await this.feedback.showLoading(async () => await this.boardTemplateSrv.createDefaultTemplate(), "Neues Board wird erstellt...")
  }

  /**
   * Fügt ein neues Ticket zur angegebenen Board-ID hinzu.
   * 
   * @param boardId - Die ID des Boards, zu dem das Ticket hinzugefügt werden soll.
   * @param event - Das Ereignis, das ausgelöst wurde, um das Hinzufügen des Tickets zu stoppen.
   */
  public async addNewTicket(boardId: number, event?: any){
    if(event) event?.stopPropagation()
    await this.feedback.openModal<TicketBase>(AddTicketPage, {status: boardId}, async (result: HttpFunctionResult<TicketBase>)=>{
      if(!result.success) return
      await this.loadBoard()
      const ticket: BoardTicket = this.boardSrv.boards.find(b => b.id == boardId).tickets.find(t => t.id == result.data.id)
      ticket.highlighted = true
      setTimeout(() => ticket.highlighted = false, 3000);
    })
  }

  //#region öffnen der Filter
  
  /**
   * Öffnet ein Modalfenster zur Auswahl eines Datums für das Board.
   * @returns Eine Promise, die das ausgewählte Datum zurückgibt.
   */
  public async openTimeSelect(){
    await this.feedback.openModal<BoardSelectDate>(BoardTimeSelectComponent, {selectedDate: Object.assign({},this.selectedDate)}, async(result)=>{
      if(!result.success) return
      this.selectedDate = result.data
      this.storageManager.setItem<BoardSelectDate>("BOARD_DATE_SELECT", this.selectedDate)
      // this.setActiveFilters()
      await this.loadBoard()
    })
  }

  /**
   * Öffnet ein Popover zur Auswahl von Benutzern für das Board.
   * @param event Das Event-Objekt, das den Aufruf ausgelöst hat.
   * @returns Eine Promise, die aufgelöst wird, sobald die Benutzer ausgewählt wurden.
   */
  public async openUserSelect(event: any){
    await this.feedback.openPopover(BoardUserSelectComponent, event, {}, async ()=>{
      this.loadBoard()
      // this.setActiveFilters()
      await this.storageManager.setItem("BOARD_USERS_SELECT", this.boardSrv.employees.filter(u => u.checked).map(u => u.id))
    })
  }

  /**
   * Öffnet den Editor-Filter-Popover.
   * @param event Das Ereignis, das den Aufruf ausgelöst hat.
   * @returns Eine Promise, die aufgelöst wird, wenn der Popover geschlossen wird.
   */
  public async openEditorFilter(event: any){
    await this.feedback.openPopover(BoardEdiorviewerSelectComponent, event, {}, async ()=>{
      this.loadBoard()
      // this.setActiveFilters()
      await this.storageManager.setItem("BOARD_EDITOR_FILTER", this.boardSrv.selectedEditorFilter)
    })
  }

  public async openCardViewEditor(event: any){
    await this.feedback.openPopover(BoardCardViewEditorComponent, event, {
      cardView: this.boardTemplateSrv.activeBoardTemplate?.boardCardView,
      viewChanged: () => {
        this.changedFilter.cardView = true
        this.boardTemplateSrv.activeBoardTemplate.boardCardView = this.boardSrv.boardView
        this.boardSrv.loadAllTargetTimes(this.boardSrv.boards)
      }
    })
  }

  //#endregion

  //#endregion

  
  /**
   * Behandelt das Scroll-Ereignis und aktualisiert die Position der Board-Wrapper-Labels.
   * @param event Das Scroll-Ereignis.
   */
  public handleScroll(event: any){  
    const nativeBoards = Array.from(document.querySelectorAll(".board-wrapper"))

    if(this.isSinglePage)this.settingsWrapperHeight = `${this.settingsWrapper.nativeElement.clientHeight + 37}px`
    else this.settingsWrapperHeight = `${this.settingsWrapper.nativeElement.clientHeight}px`

    nativeBoards.forEach(nb => {
      const nbRect = nb.getBoundingClientRect();
      const menuClosedPx: number = this.isSinglePage ? 0 : 50;
      (nb.getElementsByClassName("wrapper-label")[0] as any).style.left = event.detail.scrollTop >= 30 ? `${nbRect.x - (this.menuSrv.isMenuOpenValue ? 260 : menuClosedPx)}px` : null
    })
    this.ionContentScrollDetails = {currentX: event.detail.currentX, currentY: event.detail.currentY}
    
    this.wrapperHeaderFixxed = event.detail.scrollTop >= 30
  }

  /**
   * Versteckt oder zeigt eine Board-Gruppe und aktualisiert die Ansicht.
   * @param group - Die Board-Gruppe, die versteckt oder angezeigt werden soll.
   * @param hidden - Ein boolescher Wert, der angibt, ob die Board-Gruppe versteckt oder angezeigt werden soll.
   * @returns Eine Promise, die aufgelöst wird, sobald die Board-Gruppe versteckt oder angezeigt wurde und die Ansicht aktualisiert wurde.
   */
  public async hideUnhideGroup(group: Board, hidden: boolean){
    this.changedFilter.statusView = true
    group.hidden = hidden
    this.changeDetector.detectChanges()
    this.initBoardDragGesture()
    this.dropableBoardLines = Array.from(document.querySelectorAll(".board-drop-line"))
    this.hiddenBoards = Array.from(document.querySelectorAll(".hidden-group-item"))
    await this.storageManager.setItem<number[]>("HIDDEN_BOARDS", this.boardSrv.boards.filter(b => b.hidden).map(b => b.id))
  }

  /**
   * Öffnet eine versteckte Gruppe und zeigt die zugehörigen Tickets in einem Popover an.
   * @param event - Das Event, das den Aufruf ausgelöst hat.
   * @param board - Das Board, zu dem die versteckte Gruppe gehört.
   */
  public async openHiddenGroup(event: any,board: Board){
    await this.feedback.openPopover<PopoverListItem>(PopoverPage, event, 
      {list: board.tickets.map(t => ({id: t.id, description: t.description, icon: "fa-ticket"}))}, 
      async (result: HttpFunctionResult<PopoverListItem>)=>{
        if(!result.success) return
        this.genralSrv.setActiveTicket(board.tickets.find(t => t.id == result.data.id))
        await this.feedback.openModal(TicketDetailPagePage, {isModal: true})
      })
  }

  /**
   * Speichern der Filter die in der Board-Ansicht verwendet werden.
   */
  public async saveFilter(){

    await this.feedback.updateLoading("Filter werden gespeichert...")
    let saveActions: Promise<HttpFunctionResult<any>>[] = []
    if(this.changedFilter.color) saveActions.push(this.boardTemplateSrv.updateBoardFilterBase(this.boardTemplateSrv.activeBoardTemplate))
    if(this.changedFilter.statusView) saveActions.push(this.boardTemplateSrv.updateBoardFilterStatusViewSelect(this.boardSrv.boards.map(b => ({id: b.id, name: b.label, active: !(b.hidden == true)})), this.boardTemplateSrv.activeBoardTemplate.id))
    if(this.changedFilter.cardView) saveActions.push(this.boardTemplateSrv.updateBoardFilterCardView(this.boardSrv.boardView, this.boardTemplateSrv.activeBoardTemplate.id))
    
    const results: HttpFunctionResult<any>[] = await Promise.all(saveActions)
    await this.feedback.hideLoading()

    if(results.every(r => r.success)) this.resetFilterChanged()

  }

}
